import { action, defineNotificationStream } from "../../define.js";
export const testimonialNotifications = defineNotificationStream({
    service: "content-pipeline",
    stream: "testimonial",
    description: "Audit trail of testimonial changes (Research)",
    actions: {
        create: action("Emitted when a testimonial is created"),
        approve: action("Emitted when a testimonial is approved"),
        reject: action("Emitted when a testimonial is rejected or taken down"),
        suspend: action("Emitted when a testimonial is suspended"),
        update: action("Emitted when testimonial fields change"),
        update_contact_id: action("Emitted when the contact of a testimonial changes"),
        unlink_lawyer: action("Emitted when the lawyer contact and name are removed from a testimonial"),
        move_practice_area: action("Emitted when a testimonial is moved to another practice area"),
        reorder: action("Emitted when testimonials of a company are reordered"),
        survey_response_removed: action("Emitted when a testimonial is withdrawn because its survey response was removed"),
        auto_approve: action("Emitted when a testimonial is auto-approved"),
        delete: action("Emitted when a testimonial is deleted"),
        backfill: action("Emitted when a testimonial is created by a backfill job"),
        fix: action("Emitted when a one-off fix changes a testimonial"),
    },
});
export const TESTIMONIAL_AUDIT_ACTIONS = Object.keys(testimonialNotifications.actions);
//# sourceMappingURL=testimonial.js.map